import { Actions, helper } from '@appbaseio/reactivecore';
import { a as _extends, b as _objectWithoutPropertiesLoose } from './_rollupPluginBabelHelpers-0f24d612.js';
import VueTypes from 'vue-types';
import { componentTypes } from '@appbaseio/reactivecore/lib/utils/constants';
import { t as types } from './vueTypes-e89c8a3c.js';
import '@appbaseio/reactivecore/lib/utils/transform';
import 'redux';
import { f as updateCustomQuery, u as updateDefaultQuery, i as isQueryIdentical, c as connect } from './index-cb1950b6.js';
import { C as ComponentWrapper } from './ComponentWrapper-4f85a67e.js';

var _excluded = ["options"],
    _excluded2 = ["query"],
    _excluded3 = ["query"],
    _excluded4 = ["query"];
var updateQuery = Actions.updateQuery,
    setQueryOptions = Actions.setQueryOptions,
    setCustomQuery = Actions.setCustomQuery,
    setDefaultQuery = Actions.setDefaultQuery;
var parseHits = helper.parseHits,
    isEqual = helper.isEqual,
    getCompositeAggsQuery = helper.getCompositeAggsQuery,
    getOptionsFromQuery = helper.getOptionsFromQuery,
    getResultStats = helper.getResultStats;
var ReactiveComponent = {
  name: 'ReactiveComponent',
  props: {
    componentId: types.stringRequired,
    aggregationField: types.string,
    aggregationSize: VueTypes.number,
    size: VueTypes.number.def(20),
    defaultQuery: types.func,
    customQuery: types.func,
    filterLabel: types.string,
    react: types.react,
    showFilter: VueTypes.bool.def(true),
    URLParams: VueTypes.bool.def(false),
    distinctField: types.string,
    distinctFieldConfig: types.props,
    index: VueTypes.string
  },
  created: function created() {
    var _this = this;

    var props = this.$props;
    this.internalComponent = null;
    this.$defaultQuery = null; // Set custom query in store

    updateCustomQuery(this.componentId, this.setCustomQuery, this.$props, undefined);
    var customQuery = props.customQuery,
        componentId = props.componentId,
        filterLabel = props.filterLabel,
        showFilter = props.showFilter,
        URLParams = props.URLParams,
        distinctField = props.distinctField,
        distinctFieldConfig = props.distinctFieldConfig,
        index = props.index;

    if (this.enableAppbase && this.aggregationField && this.aggregationField !== '') {
      console.warn('Warning(ReactiveSearch): The `aggregationField` prop has been marked as deprecated, please use the `distinctField` prop instead.');
    }

    if (!this.enableAppbase && (distinctField || distinctFieldConfig)) {
      console.warn('Warning(ReactiveSearch): In order to use the `distinctField` and `distinctFieldConfig` props, the `enableAppbase` prop must be set to true in `ReactiveBase`.');
    }

    if (!this.enableAppbase && index) {
      console.warn('Warning(ReactiveSearch): In order to use the `index` prop, the `enableAppbase` prop must be set to true in `ReactiveBase`.');
    }

    if (customQuery) {
      var calcCustomQuery = customQuery(props);

      var _ref = calcCustomQuery || {},
          query = _ref.query;

      var customQueryOptions = calcCustomQuery ? getOptionsFromQuery(calcCustomQuery) : null;

      if (customQueryOptions) {
        this.setQueryOptions(componentId, _extends({}, customQueryOptions, this.getAggsQuery()), false);
      } else this.setQueryOptions(componentId, this.getAggsQuery(), false);

      var queryToSet = query || null;

      if (calcCustomQuery && calcCustomQuery.id) {
        queryToSet = calcCustomQuery;
      }

      this.updateQuery({
        componentId: componentId,
        queryToSet: queryToSet,
        value: this.selectedValue || null,
        label: filterLabel,
        showFilter: showFilter,
        URLParams: URLParams
      });
    }

    this.setQuery = function (_ref2) {
      var options = _ref2.options,
          obj = _objectWithoutPropertiesLoose(_ref2, _excluded);

      if (options) {
        _this.setQueryOptions(props.componentId, _extends({}, options, _this.getAggsQuery()), false);
      }

      var queryToBeSet = obj.query; // when enableAppbase is true, Backend throws error because of repeated query in request body

      if (obj && obj.query && obj.query.query) {
        queryToBeSet = obj.query.query;
      } // Update customQuery field for RS API


      if (obj && obj.query || options) {
        var customQueryCalc = _extends({}, options);

        if (obj && obj.query) {
          if (obj.query.id) {
            customQueryCalc = queryToBeSet;
          } else {
            customQueryCalc.query = obj.query;
          }
        }

        _this.setCustomQuery(props.componentId, customQueryCalc);
      }

      _this.updateQuery(_extends({}, obj, {
        componentId: props.componentId,
        label: props.filterLabel,
        showFilter: props.showFilter,
        URLParams: props.URLParams
      }));
    };

    if (props.defaultQuery) {
      this.internalComponent = props.componentId + "__internal";
    }
  },
  beforeMount: function beforeMount() {
    if (this.internalComponent && this.$props.defaultQuery) {
      updateDefaultQuery(this.componentId, this.setDefaultQuery, this.$props, undefined);
      this.$defaultQuery = this.$props.defaultQuery();

      var _ref3 = this.$defaultQuery || {},
          query = _ref3.query,
          queryOptions = _objectWithoutPropertiesLoose(_ref3, _excluded2);

      if (queryOptions) {
        this.setQueryOptions(this.internalComponent, _extends({}, queryOptions, this.getAggsQuery()), false);
      } else this.setQueryOptions(this.internalComponent, this.getAggsQuery(), false);

      var queryToSet = query || null;

      if (!queryToSet && this.$defaultQuery && this.$defaultQuery.id) {
        queryToSet = this.$defaultQuery;
      }

      this.updateQuery({
        componentId: this.internalComponent,
        query: queryToSet
      });
    }
  },
  watch: {
    hits: function hits(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.$emit('data', this.getData());
      }
    },
    rawData: function rawData(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.$emit('data', this.getData());
      }
    },
    aggregations: function aggregations(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.$emit('data', this.getData());
      }
    },
    aggregationData: function aggregationData(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.$emit('data', this.getData());
      }
    },
    promotedResults: function promotedResults(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.$emit('data', this.getData());
      }
    },
    hidden: function hidden(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.$emit('data', this.getData());
      }
    },
    total: function total(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.$emit('data', this.getData());
      }
    },
    time: function time(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.$emit('data', this.getData());
      }
    },
    defaultQuery: function defaultQuery(newVal, oldVal) {
      if (newVal && !isQueryIdentical(newVal, oldVal, undefined, this.$props)) {
        this.$defaultQuery = newVal();

        var _ref4 = this.$defaultQuery || {},
            query = _ref4.query,
            queryOptions = _objectWithoutPropertiesLoose(_ref4, _excluded3);

        if (queryOptions) {
          this.setQueryOptions(this.internalComponent, _extends({}, queryOptions, this.getAggsQuery()), false);
        } else this.setQueryOptions(this.internalComponent, this.getAggsQuery(), false); // Update default query for RS API


        updateDefaultQuery(this.componentId, this.setDefaultQuery, this.$props, undefined);
        var queryToSet = query || null;

        if (!queryToSet && this.$defaultQuery && this.$defaultQuery.id) {
          queryToSet = this.$defaultQuery;
        }

        this.updateQuery({
          componentId: this.internalComponent,
          query: queryToSet
        });
      }
    },
    customQuery: function customQuery(newVal, oldVal) {
      if (newVal && !isQueryIdentical(newVal, oldVal, undefined, this.$props)) {
        var componentId = this.$props.componentId;
        this.$customQuery = newVal(this.$props);

        var _ref5 = this.$customQuery || {},
            query = _ref5.query,
            queryOptions = _objectWithoutPropertiesLoose(_ref5, _excluded4);

        if (queryOptions) {
          this.setQueryOptions(componentId, _extends({}, queryOptions, this.getAggsQuery()), false);
        } else this.setQueryOptions(componentId, this.getAggsQuery(), false); // Update custom query for RS API


        updateCustomQuery(this.componentId, this.setCustomQuery, this.$props, undefined);
        var queryToSet = query || null;

        if (this.$customQuery && this.$customQuery.id) {
          queryToSet = this.$customQuery;
        }

        this.updateQuery({
          componentId: componentId,
          query: queryToSet
        });
      }
    }
  },
  render: function render() {
    var h = arguments[0];

    try {
      var dom = this.$scopedSlots["default"];
      var error = this.error,
          isLoading = this.isLoading,
          selectedValue = this.selectedValue;

      var propsToBePassed = _extends({
        error: error,
        loading: isLoading
      }, this.getData(), {
        value: selectedValue,
        setQuery: this.setQuery
      });

      return h("div", [dom(propsToBePassed)]);
    } catch (e) {
      return null;
    }
  },
  methods: {
    getAggsQuery: function getAggsQuery() {
      if (this.aggregationField) {
        return {
          aggs: getCompositeAggsQuery({
            props: this.$props,
            showTopHits: true,
            value: this.selectedValue
          }).aggs
        };
      }

      return {};
    },
    getData: function getData() {
      var hits = this.hits,
          aggregations = this.aggregations,
          aggregationData = this.aggregationData,
          promotedResults = this.promotedResults,
          rawData = this.rawData;
      var filteredResults = parseHits(hits);

      if (promotedResults.length) {
        var ids = promotedResults.map(function (item) {
          return item._id;
        }).filter(Boolean);

        if (ids) {
          filteredResults = filteredResults.filter(function (item) {
            return !ids.includes(item._id);
          });
        }

        filteredResults = [].concat(promotedResults, filteredResults);
      }

      return {
        data: filteredResults,
        aggregationData: aggregationData,
        rawData: rawData,
        aggregations: aggregations,
        promotedData: promotedResults,
        resultStats: this.stats
      };
    }
  },
  computed: {
    stats: function stats() {
      return getResultStats(this);
    }
  }
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    aggregations: state.aggregations[props.componentId] && state.aggregations[props.componentId] || null,
    aggregationData: state.compositeAggregations[props.componentId] || [],
    hits: state.hits[props.componentId] && state.hits[props.componentId].hits || [],
    rawData: state.rawData[props.componentId],
    error: state.error[props.componentId],
    isLoading: state.isLoading[props.componentId],
    selectedValue: state.selectedValues[props.componentId] && state.selectedValues[props.componentId].value || null,
    promotedResults: state.promotedResults[props.componentId] || [],
    time: state.hits[props.componentId] && state.hits[props.componentId].time || 0,
    total: state.hits[props.componentId] && state.hits[props.componentId].total,
    hidden: state.hits[props.componentId] && state.hits[props.componentId].hidden,
    componentProps: state.props[props.componentId],
    enableAppbase: state.config.enableAppbase
  };
};

var mapDispatchtoProps = {
  setQueryOptions: setQueryOptions,
  updateQuery: updateQuery,
  setCustomQuery: setCustomQuery,
  setDefaultQuery: setDefaultQuery
};
var RcConnected = ComponentWrapper(connect(mapStateToProps, mapDispatchtoProps)(ReactiveComponent), {
  componentType: componentTypes.reactiveComponent
});

ReactiveComponent.install = function (Vue) {
  Vue.component(ReactiveComponent.name, RcConnected);
}; // Add componentType for SSR


ReactiveComponent.componentType = componentTypes.reactiveComponent;

export default ReactiveComponent;
